/* parser generated by jison 0.4.17 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var parascript = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[5,9,10,11,23,26,29,30,31,32,35,36,39,69,70,80,82,83,85,96,97,98,101],$V1=[1,30],$V2=[1,38],$V3=[1,15],$V4=[1,16],$V5=[1,22],$V6=[1,19],$V7=[1,23],$V8=[1,24],$V9=[1,25],$Va=[1,26],$Vb=[1,27],$Vc=[1,62],$Vd=[1,61],$Ve=[1,63],$Vf=[1,64],$Vg=[1,65],$Vh=[1,49],$Vi=[1,46],$Vj=[1,47],$Vk=[1,48],$Vl=[1,50],$Vm=[5,9,10,11,23,25,26,28,29,30,31,32,35,36,39,69,70,80,82,83,85,96,97,98,101],$Vn=[10,11,23,25,26,29,30,31,32,35,36,39,69,70,80,82,83,85,96,97,98,101],$Vo=[1,76],$Vp=[1,81],$Vq=[13,15,25,30,86],$Vr=[2,98],$Vs=[1,83],$Vt=[1,85],$Vu=[1,86],$Vv=[1,87],$Vw=[1,88],$Vx=[2,77],$Vy=[1,90],$Vz=[1,91],$VA=[1,93],$VB=[13,15,25,30,51,52,54,56,58,60,62,64,66,69,70,73,74,75,86],$VC=[13,15,25,30,51,52,54,86],$VD=[1,96],$VE=[13,15,25,30,51,52,54,56,58,60,62,64,66,69,70,73,74,75,85,86,87],$VF=[13,15,25,30,51,52,54,56,86],$VG=[1,98],$VH=[13,15,25,30,51,52,54,56,58,86],$VI=[1,99],$VJ=[2,39],$VK=[13,15,25,30,51,52,54,56,58,60,86],$VL=[1,102],$VM=[13,15,25,30,51,52,54,56,58,60,62,86],$VN=[1,103],$VO=[13,15,25,30,51,52,54,56,58,60,62,64,86],$VP=[1,104],$VQ=[13,15,25,30,51,52,54,56,58,60,62,64,66,86],$VR=[1,106],$VS=[1,107],$VT=[13,15,25,30,51,52,54,56,58,60,62,64,66,69,70,86],$VU=[1,109],$VV=[1,110],$VW=[1,111],$VX=[1,114],$VY=[10,11,69,70,80,82,83,85,96,97,98,101],$VZ=[15,25],$V_=[1,123],$V$=[15,30],$V01=[13,15],$V11=[10,11,23,69,70,80,82,83,85,96,97,98,101],$V21=[1,143],$V31=[13,15,86],$V41=[1,151],$V51=[13,15,25,30,42,49,51,52,54,56,58,60,62,64,66,69,70,73,74,75,85,86,87];
var parser = {trace: function trace() { },
yy: {},
symbols_: {"error":2,"Program":3,"ProgramElements":4,"EOF":5,"ProgramElement":6,"Statement":7,"FunctionDeclaration":8,"FUNCTION":9,"IDENTIFIER":10,"(":11,"ArgumentList":12,")":13,"Block":14,",":15,"Argument":16,"SelectionStatement":17,"IterationStatement":18,"ExpressionStatement":19,"BreakStatement":20,"ContinueStatement":21,"ReturnStatement":22,"{":23,"StatementList":24,"}":25,"IF":26,"Expression":27,"ELSE":28,"BREAK":29,";":30,"CONTINUE":31,"RETURN":32,"ForStatement":33,"WhileStatement":34,"FOR":35,"WHILE":36,"VarStatement":37,"ExpressionNoMapLiteral":38,"VAR":39,"DeclarationList":40,"Declaration":41,"=":42,"ExpressionList":43,"MapLiteral":44,"AssignmentExpression":45,"TernaryExpression":46,"AssignmentOperator":47,"MemberExpression":48,"ARITHMETIC_ASSIGNMENT_OPERATOR":49,"LogicalOrExpression":50,"?":51,":":52,"LogicalAndExpression":53,"||":54,"BitwiseOrExpression":55,"&&":56,"BitwiseAndExpression":57,"|":58,"BitwiseXorExpression":59,"&":60,"EqualityExpression":61,"^":62,"RelationalExpression":63,"LOGICAL_EQUALITY":64,"AddSubExpression":65,"RELATIONAL_OPERATOR":66,"MulDivExpression":67,"AddSubOperator":68,"+":69,"-":70,"UnaryExpression":71,"MulDivOperator":72,"*":73,"/":74,"%":75,"PostfixExpression":76,"PrefixExpression":77,"PrimaryExpression":78,"UnaryOperator":79,"!":80,"PostfixOperator":81,"++":82,"--":83,"PrefixOperator":84,"[":85,"]":86,".":87,"Literal":88,"Identifier":89,"FunctionCall":90,"BooleanLiteral":91,"NumericLiteral":92,"StringLiteral":93,"ArrayLiteral":94,"NullLiteral":95,"BOOLEAN":96,"NUMERIC_LITERAL":97,"STRING":98,"PropertyList":99,"Property":100,"NULL":101,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",9:"FUNCTION",10:"IDENTIFIER",11:"(",13:")",15:",",23:"{",25:"}",26:"IF",28:"ELSE",29:"BREAK",30:";",31:"CONTINUE",32:"RETURN",35:"FOR",36:"WHILE",39:"VAR",42:"=",49:"ARITHMETIC_ASSIGNMENT_OPERATOR",51:"?",52:":",54:"||",56:"&&",58:"|",60:"&",62:"^",64:"LOGICAL_EQUALITY",66:"RELATIONAL_OPERATOR",69:"+",70:"-",73:"*",74:"/",75:"%",80:"!",82:"++",83:"--",85:"[",86:"]",87:".",96:"BOOLEAN",97:"NUMERIC_LITERAL",98:"STRING",101:"NULL"},
productions_: [0,[3,2],[4,2],[4,0],[6,1],[6,1],[8,6],[12,0],[12,3],[12,1],[16,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[14,3],[17,5],[17,7],[20,2],[21,2],[22,2],[22,3],[18,1],[18,1],[33,8],[34,5],[19,1],[19,1],[19,2],[37,3],[40,1],[40,3],[41,1],[41,3],[24,2],[24,0],[43,0],[43,3],[43,1],[27,1],[27,1],[38,1],[45,1],[45,3],[45,3],[47,1],[47,1],[46,1],[46,5],[50,1],[50,3],[53,1],[53,3],[55,1],[55,3],[57,1],[57,3],[59,1],[59,3],[61,1],[61,3],[63,1],[63,3],[65,1],[65,3],[68,1],[68,1],[67,1],[67,3],[72,1],[72,1],[72,1],[71,1],[71,1],[71,1],[71,1],[71,2],[79,1],[79,1],[79,1],[76,2],[81,1],[81,1],[77,2],[84,1],[84,1],[48,4],[48,4],[48,3],[48,3],[78,1],[78,1],[78,1],[78,3],[90,4],[89,1],[88,1],[88,1],[88,1],[88,1],[88,1],[91,1],[92,1],[93,1],[94,3],[44,3],[99,0],[99,3],[99,1],[100,3],[95,1]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:

            // false: ensure this ListASTNode does not enter nested scope (stay in global)
            this.$ = new PARAPPLE.ast.ListASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), $$[$0-1], false);
            return this.$;
        
break;
case 2:

            this.$ = $$[$0-1].concat($$[$0]);
        
break;
case 3:

            this.$ = [];
        
break;
case 6:

          this.$ = new PARAPPLE.ast.FunctionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-5], _$[$0]), $$[$0-4], $$[$0-2], $$[$0]);
      
break;
case 8:

        this.$ = $$[$0-2].concat($$[$0]);
      
break;
case 9: case 33:

        this.$ = [ $$[$0] ];
      
break;
case 18:

            // ListASTNode, true: enter nested scope
            this.$ = new PARAPPLE.ast.ListASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-1], true);
          
break;
case 19:

          this.$ = new PARAPPLE.ast.IfASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-4], _$[$0]), $$[$0-2], $$[$0], null);
        
break;
case 20:

          this.$ = new PARAPPLE.ast.IfASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-6], _$[$0]), $$[$0-4], $$[$0-2], $$[$0]);
        
break;
case 21:

            this.$ = new PARAPPLE.ast.BreakASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]));
          
break;
case 22:

            this.$ = new PARAPPLE.ast.ContinueASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]));
          
break;
case 23:

              this.$ = new PARAPPLE.ast.ReturnASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), null);
          
break;
case 24:

              this.$ = new PARAPPLE.ast.ReturnASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0-1]), $$[$0-1]);
          
break;
case 27:

        this.$ = new PARAPPLE.ast.ForASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-7], _$[$0]),  $$[$0-5], $$[$0-4], $$[$0-2], $$[$0]);
      
break;
case 28:

          this.$ = new PARAPPLE.ast.WhileASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-4], _$[$0]), $$[$0-2], $$[$0]);
        
break;
case 29:

        this.$ = new PARAPPLE.ast.EmptyASTNode();
      
break;
case 31:

          // Expression statements need to be followed by a POP instructions, that is
          // why we need to nest the expression node under an expression statement node.
          this.$ = new PARAPPLE.ast.ExpressionStatementASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0-1]), $$[$0-1]);
        
break;
case 32:

          // false: do not enter nested scope
          this.$ = new PARAPPLE.ast.ListASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-1], false);
        
break;
case 34:

        this.$ = $$[$0-2].concat($$[$0])
      
break;
case 35:

          this.$ = new PARAPPLE.ast.VarASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), $$[$0], null);
        
break;
case 36:

          this.$ = new PARAPPLE.ast.VarASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0]);
        
break;
case 37:

              this.$ = $$[$0-1].concat($$[$0]);
          
break;
case 38:

              this.$ = [];
          
break;
case 40:

          this.$ = $$[$0-2].concat($$[$0]);
        
break;
case 41:

          this.$ = [ $$[$0] ];
        
break;
case 46:

          this.$ = new PARAPPLE.ast.IdentifierAssignmentASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0], $$[$0-1]);
      
break;
case 47:

          this.$ = new PARAPPLE.ast.MemberAssignmentASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0], $$[$0-1]);
      
break;
case 51:

        this.$ = new PARAPPLE.ast.TernaryExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-4], _$[$0]), $$[$0-4], $$[$0-2], $$[$0]);
      
break;
case 53: case 55: case 57: case 59: case 61: case 63: case 65: case 67: case 71:

        this.$ = new PARAPPLE.ast.BinaryExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0], $$[$0-1]);
      
break;
case 79:

        this.$ = new PARAPPLE.ast.UnaryExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), $$[$0-1], $$[$0]);
      
break;
case 83:

        this.$ = new PARAPPLE.ast.PostfixExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), $$[$0-1], $$[$0]);
      
break;
case 86:

        this.$ = new PARAPPLE.ast.PrefixExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-1], _$[$0]), $$[$0], $$[$0-1]);
      
break;
case 89: case 90:

        this.$ = new PARAPPLE.ast.MemberExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-3], _$[$0]), $$[$0-3], $$[$0-1], true);
      
break;
case 91: case 92:

        this.$ = new PARAPPLE.ast.MemberExpressionASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0]);
      
break;
case 96:

        this.$ = $$[$0-1]
      
break;
case 97:

        this.$ = new PARAPPLE.ast.FunctionCallASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-3], _$[$0]), $$[$0-3], $$[$0-1]);
      
break;
case 98:

      this.$ = new PARAPPLE.ast.IdentifierASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), $$[$0]);
    
break;
case 104: case 106:

        this.$ = new PARAPPLE.ast.LiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), $$[$0]);
      
break;
case 105:

      this.$ = new PARAPPLE.ast.LiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), $$[$0]);
    
break;
case 107:

      this.$ = new PARAPPLE.ast.ArrayLiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-1])
    
break;
case 108:

      this.$ = new PARAPPLE.ast.MapLiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-1])
    
break;
case 110:

      this.$ = $$[$0-2].concat($$[$0]);
    
break;
case 111:

      this.$ = [ $$[$0] ];
    
break;
case 112:

      this.$ = new PARAPPLE.ast.PropertyASTNode(new PARAPPLE.ast.SourceLocation(_$[$0-2], _$[$0]), $$[$0-2], $$[$0]);
    
break;
case 113:

        this.$ = new PARAPPLE.ast.LiteralASTNode(new PARAPPLE.ast.SourceLocation(_$[$0], _$[$0]), null);
      
break;
}
},
table: [o($V0,[2,3],{3:1,4:2}),{1:[3]},{5:[1,3],6:4,7:5,8:6,9:[1,14],10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{1:[2,1]},o($V0,[2,2]),o($V0,[2,4]),o($V0,[2,5]),o($Vm,[2,11]),o($Vm,[2,12]),o($Vm,[2,13]),o($Vm,[2,14]),o($Vm,[2,15]),o($Vm,[2,16]),o($Vm,[2,17]),{10:[1,66]},o($Vn,[2,38],{24:67}),{11:[1,68]},o($Vm,[2,25]),o($Vm,[2,26]),o($Vm,[2,29]),o($Vm,[2,30]),{30:[1,69]},{30:[1,70]},{30:[1,71]},{10:$V1,11:$V2,23:$Vo,27:73,30:[1,72],38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{11:[1,77]},{11:[1,78]},{10:$Vp,40:79,41:80},o($Vq,[2,44]),o($Vq,[2,45]),o([13,15,25,30,51,54,56,58,60,62,64,66,69,70,73,74,75,85,86,87],$Vr,{47:82,81:84,11:$Vs,42:$Vt,49:$Vu,82:$Vv,83:$Vw}),o([13,15,25,30,51,54,56,58,60,62,64,66,69,70,73,74,75,86],$Vx,{47:89,42:$Vt,49:$Vu,85:$Vy,87:$Vz}),o($Vq,[2,50],{51:[1,92],54:$VA}),o($VB,[2,78],{85:[1,94],87:[1,95]}),o($VC,[2,52],{56:$VD}),o($VE,[2,93]),o($VE,[2,94]),o($VE,[2,95]),{10:$V1,11:$V2,23:$Vo,27:97,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($VF,[2,54],{58:$VG}),o($VE,[2,99]),o($VE,[2,100]),o($VE,[2,101]),o($VE,[2,102]),o($VE,[2,103]),o($VH,[2,56],{60:$VI}),o($VE,[2,104]),o($VE,[2,105]),o($VE,[2,106]),o([15,86],$VJ,{45:28,46:29,48:31,50:32,78:33,53:34,88:35,89:36,90:37,55:39,91:40,92:41,93:42,94:43,95:44,57:45,59:51,61:52,63:53,65:54,67:55,71:56,76:57,77:58,79:59,84:60,38:74,44:75,43:100,27:101,10:$V1,11:$V2,23:$Vo,69:$Vc,70:$Vd,80:$Ve,82:$Vf,83:$Vg,85:$Vh,96:$Vi,97:$Vj,98:$Vk,101:$Vl}),o($VE,[2,113]),o($VK,[2,58],{62:$VL}),o($VM,[2,60],{64:$VN}),o($VO,[2,62],{66:$VP}),o($VQ,[2,64],{68:105,69:$VR,70:$VS}),o($VT,[2,66],{72:108,73:$VU,74:$VV,75:$VW}),o($VB,[2,70]),o($VB,[2,75]),o($VB,[2,76]),{10:$VX,11:$V2,48:113,69:$Vc,70:$Vd,71:112,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:[1,115]},o($VY,[2,80]),o($VY,[2,81]),o($VY,[2,82]),{10:[2,87]},{10:[2,88]},{11:[1,116]},{7:118,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,25:[1,117],26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$V1,11:$V2,23:$Vo,27:119,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vm,[2,31]),o($Vm,[2,21]),o($Vm,[2,22]),o($Vm,[2,23]),{30:[1,120]},o($Vq,[2,42]),o($Vq,[2,43]),o($VZ,[2,109],{99:121,100:122,10:$V_}),{10:$V1,11:$V2,19:124,30:$V6,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$V1,11:$V2,23:$Vo,27:125,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{15:[1,127],30:[1,126]},o($V$,[2,33]),o($V$,[2,35],{42:[1,128]}),{10:$V1,11:$V2,23:$Vo,27:129,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($V01,$VJ,{45:28,46:29,48:31,50:32,78:33,53:34,88:35,89:36,90:37,55:39,91:40,92:41,93:42,94:43,95:44,57:45,59:51,61:52,63:53,65:54,67:55,71:56,76:57,77:58,79:59,84:60,38:74,44:75,27:101,43:130,10:$V1,11:$V2,23:$Vo,69:$Vc,70:$Vd,80:$Ve,82:$Vf,83:$Vg,85:$Vh,96:$Vi,97:$Vj,98:$Vk,101:$Vl}),o($VB,[2,83]),o($V11,[2,48]),o($V11,[2,49]),o($VB,[2,84]),o($VB,[2,85]),{10:$V1,11:$V2,23:$Vo,27:131,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$V1,11:$V2,23:$Vo,27:132,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:[1,133]},{10:$VX,11:$V2,48:113,50:134,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,53:135,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$V1,11:$V2,23:$Vo,27:136,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:[1,137]},{10:$VX,11:$V2,48:113,55:138,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{13:[1,139]},{10:$VX,11:$V2,48:113,57:140,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,59:141,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{15:$V21,86:[1,142]},o($V31,[2,41]),{10:$VX,11:$V2,48:113,61:144,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,63:145,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,65:146,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{10:$VX,11:$V2,48:113,67:147,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($VY,[2,68]),o($VY,[2,69]),{10:$VX,11:$V2,48:113,69:$Vc,70:$Vd,71:148,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($VY,[2,72]),o($VY,[2,73]),o($VY,[2,74]),o($VB,[2,79]),o($VB,$Vx,{85:$Vy,87:$Vz}),o($VE,$Vr,{81:84,11:$Vs,82:$Vv,83:$Vw}),o($VB,[2,86]),o($V01,[2,7],{12:149,16:150,10:$V41}),o($Vm,[2,18]),o($Vn,[2,37]),{13:[1,152]},o($Vm,[2,24]),{15:[1,154],25:[1,153]},o($VZ,[2,111]),{52:[1,155]},{10:$V1,11:$V2,23:$Vo,27:156,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{13:[1,157]},o($Vm,[2,32]),{10:$Vp,41:158},{10:$V1,11:$V2,23:$Vo,27:159,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vq,[2,46]),{13:[1,160],15:$V21},o($Vq,[2,47]),{86:[1,161]},o($V51,[2,92]),{52:[1,162],54:$VA},o($VC,[2,53],{56:$VD}),{86:[1,163]},o($V51,[2,91]),o($VF,[2,55],{58:$VG}),o($VE,[2,96]),o($VH,[2,57],{60:$VI}),o($VK,[2,59],{62:$VL}),o($VE,[2,107]),{10:$V1,11:$V2,23:$Vo,27:164,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($VM,[2,61],{64:$VN}),o($VO,[2,63],{66:$VP}),o($VQ,[2,65],{68:105,69:$VR,70:$VS}),o($VT,[2,67],{72:108,73:$VU,74:$VV,75:$VW}),o($VB,[2,71]),{13:[1,165],15:[1,166]},o($V01,[2,9]),o($V01,[2,10]),{7:167,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vq,[2,108]),{10:$V_,100:168},{10:$V1,11:$V2,23:$Vo,27:169,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{30:[1,170]},{7:171,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($V$,[2,34]),o($V$,[2,36]),o($VE,[2,97]),o($V51,[2,90]),{10:$VX,11:$V2,46:172,48:113,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($V51,[2,89]),o($V31,[2,40]),{14:173,23:$V3},{10:$V41,16:174},o([5,9,10,11,23,25,26,29,30,31,32,35,36,39,69,70,80,82,83,85,96,97,98,101],[2,19],{28:[1,175]}),o($VZ,[2,110]),o($VZ,[2,112]),{10:$V1,11:$V2,23:$Vo,27:176,38:74,44:75,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vm,[2,28]),o($Vq,[2,51]),o($V0,[2,6]),o($V01,[2,8]),{7:177,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},{13:[1,178]},o($Vm,[2,20]),{7:179,10:$V1,11:$V2,14:7,17:8,18:9,19:10,20:11,21:12,22:13,23:$V3,26:$V4,29:$V5,30:$V6,31:$V7,32:$V8,33:17,34:18,35:$V9,36:$Va,37:20,38:21,39:$Vb,45:28,46:29,48:31,50:32,53:34,55:39,57:45,59:51,61:52,63:53,65:54,67:55,69:$Vc,70:$Vd,71:56,76:57,77:58,78:33,79:59,80:$Ve,82:$Vf,83:$Vg,84:60,85:$Vh,88:35,89:36,90:37,91:40,92:41,93:42,94:43,95:44,96:$Vi,97:$Vj,98:$Vk,101:$Vl},o($Vm,[2,27])],
defaultActions: {3:[2,1],64:[2,87],65:[2,88]},
parseError: function parseError(str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        function _parseError (msg, hash) {
            this.message = msg;
            this.hash = hash;
        }
        _parseError.prototype = Error;

        throw new _parseError(str, hash);
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function (match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex() {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin(condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState() {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules() {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState(n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState(condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0: // ignore whitespace 
break;
case 1: // multi-line comment 
break;
case 2: // single-line comment 
break;
case 3:return "IF";
break;
case 4:return "ELSE";
break;
case 5:return "VAR";
break;
case 6:return "FOR";
break;
case 7:return "WHILE";
break;
case 8:return "FUNCTION";
break;
case 9:return "RETURN";
break;
case 10:return "BREAK";
break;
case 11:return "CONTINUE";
break;
case 12:return "BOOLEAN";
break;
case 13:return "BOOLEAN";
break;
case 14:return "NULL";
break;
case 15:return "IDENTIFIER";
break;
case 16:return "STRING";
break;
case 17:return "NUMERIC_LITERAL";
break;
case 18:return "{";
break;
case 19:return "}";
break;
case 20:return "(";
break;
case 21:return ")";
break;
case 22:return "[";
break;
case 23:return "]";
break;
case 24:return ";";
break;
case 25:return ":";
break;
case 26:return ",";
break;
case 27:return ".";
break;
case 28:return "?";
break;
case 29:return "LOGICAL_EQUALITY";
break;
case 30:return "LOGICAL_EQUALITY";
break;
case 31:return "LOGICAL_EQUALITY";
break;
case 32:return "LOGICAL_EQUALITY";
break;
case 33:return "RELATIONAL_OPERATOR";
break;
case 34:return "RELATIONAL_OPERATOR";
break;
case 35:return "RELATIONAL_OPERATOR";
break;
case 36:return "RELATIONAL_OPERATOR";
break;
case 37:return "ARITHMETIC_ASSIGNMENT_OPERATOR";
break;
case 38:return "ARITHMETIC_ASSIGNMENT_OPERATOR";
break;
case 39:return "ARITHMETIC_ASSIGNMENT_OPERATOR";
break;
case 40:return "ARITHMETIC_ASSIGNMENT_OPERATOR";
break;
case 41:return "=";
break;
case 42:return "++";
break;
case 43:return "--";
break;
case 44:return "+";
break;
case 45:return "-";
break;
case 46:return "*";
break;
case 47:return "/";
break;
case 48:return "%";
break;
case 49:return "||"
break;
case 50:return "&&"
break;
case 51:return "|"
break;
case 52:return "&"
break;
case 53:return "^"
break;
case 54:return "!"
break;
case 55:return 5
break;
case 56:return 'Invalid_character'
break;
}
},
rules: [/^(?:\s+)/,/^(?:\/\*(.|\r|\n)*?\*\/)/,/^(?:\/\/.*($|\r\n|\r|\n))/,/^(?:if\b)/,/^(?:else\b)/,/^(?:var\b)/,/^(?:for\b)/,/^(?:while\b)/,/^(?:function\b)/,/^(?:return\b)/,/^(?:break\b)/,/^(?:continue\b)/,/^(?:true\b)/,/^(?:false\b)/,/^(?:null\b)/,/^(?:(([$_a-zA-Z])(([$_a-zA-Z])|[0-9])*))/,/^(?:(("(([^\"\\\n\r]+))*")|('(([^\'\\\n\r]+))*')))/,/^(?:((((0|([1-9])[0-9]*)?(\.([0-9])+))|((0|([1-9])[0-9]*)(\.([0-9])+)?))([Ee][+-]?([0-9])+)?))/,/^(?:\{)/,/^(?:\})/,/^(?:\()/,/^(?:\))/,/^(?:\[)/,/^(?:\])/,/^(?:;)/,/^(?::)/,/^(?:,)/,/^(?:\.)/,/^(?:\?)/,/^(?:===)/,/^(?:==)/,/^(?:!==)/,/^(?:!=)/,/^(?:>=)/,/^(?:<=)/,/^(?:>)/,/^(?:<)/,/^(?:\+=)/,/^(?:-=)/,/^(?:\*=)/,/^(?:\/=)/,/^(?:=)/,/^(?:\+\+)/,/^(?:--)/,/^(?:\+)/,/^(?:-)/,/^(?:\*)/,/^(?:\/)/,/^(?:%)/,/^(?:\|\|)/,/^(?:&&)/,/^(?:\|)/,/^(?:&)/,/^(?:\^)/,/^(?:!)/,/^(?:$)/,/^(?:.)/],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = parascript;
exports.Parser = parascript.Parser;
exports.parse = function () { return parascript.parse.apply(parascript, arguments); };
exports.main = function commonjsMain(args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}


//////////////////
// WEBPACK FOOTER
// ./src/parascript/parser/parascript.js
// module id = 1279
// module chunks = 2